import React, { memo } from 'react'
import { DropdownItem, Icon } from 'common-components'
import CheckIcon from 'assets/svgr-icons/Check.svg'
import CrownIcon from 'assets/svgr-icons/Crown.svg'
import * as Styled from './styled'
import * as DropdownItemStyled from 'common-components/DropdownItem/styled'
import { IOption } from './types'

interface IDropdownContentProps {
  options: Array<IOption>
  selectedValue: string | number | null
  onSelect: (value: string | number) => void
}

const DropdownContent: React.FC<IDropdownContentProps> = ({
  options,
  selectedValue,
  onSelect
}) => {
  return (
    <Styled.DropdownListWrapper>
      {options.map(option => {
        const isSelected = option.value === selectedValue

        return (
          <DropdownItem
            key={option.value.toString()}
            title={option.label}
            isSelected={isSelected}
            onSelect={() => onSelect(option.value)}
            renderRightContent={() => {
              if (option.isPremium) {
                return (
                  <Styled.CrownBadgeIcon
                    icon={<CrownIcon />}
                    size="small"
                    color="goldDark"
                  />
                )
              }
              if (isSelected && option.description) {
                return (
                  <DropdownItemStyled.CheckmarkWrapper>
                    <Icon
                      icon={<CheckIcon />}
                      size="medium"
                      color="primaryDark"
                    />
                  </DropdownItemStyled.CheckmarkWrapper>
                )
              }
              return null
            }}
          />
        )
      })}
    </Styled.DropdownListWrapper>
  )
}

export default memo(DropdownContent)
